import allProductPage from "./allProductPage"
export default allProductPage;
